import * as React from 'react';

interface Props {
    numbers: Array<number>;
    currentValue: number | null;
    unselectedValue: string | number | null;
    showUnselectedChoice: boolean;
    unselectedLabel: string;
    onValueChange?: (newValue: string | number | null) => void;
    isInteractive?: boolean;
}

export default class NumberBar extends React.PureComponent<Props, {}> {
    static defaultProps = {
        unselectedValue: null,
        showUnselectedChoice: false,
        unselectedLabel: '--',
    };

    handleChange = (value: string | number | null, evt: React.MouseEvent): void => {
        const { currentValue, onValueChange } = this.props;

        if (onValueChange) {
            evt.stopPropagation();
            evt.nativeEvent.stopImmediatePropagation();

            if (value !== currentValue) {
                onValueChange(value);
            }
        }
    };

    renderValue = (
        label: React.ReactNode,
        value: string | number | null,
        isActive: boolean,
        isImplied: boolean,
    ): React.ReactNode => {
        const { isInteractive } = this.props;

        let classNames: Array<string> = ['ddbc-number-bar__option'];
        if (isImplied) {
            classNames.push('ddbc-number-bar__option--implied');
        }
        if (isActive) {
            classNames.push('ddbc-number-bar__option--active');
        }
        if (isInteractive) {
            classNames.push('ddbc-number-bar__option--interactive');
        }

        return (
            <span
                key={value === null ? value + '' : value}
                className={classNames.join(' ')}
                onClick={this.handleChange.bind(this, value)}
            >
                {label}
            </span>
        );
    };

    renderValues = (): React.ReactNode => {
        const { numbers, currentValue } = this.props;

        return numbers.map((number) => {
            return this.renderValue(
                number,
                number,
                number === currentValue,
                currentValue !== null && number < currentValue,
            );
        });
    };

    render() {
        const { currentValue, unselectedValue, unselectedLabel, showUnselectedChoice } = this.props;

        return (
            <div className="ddbc-number-bar">
                {showUnselectedChoice &&
                    this.renderValue(unselectedLabel, unselectedValue, false, currentValue !== unselectedValue)}
                {this.renderValues()}
            </div>
        );
    }
}
